import React from "react";
import Image from "next/image";
import DefaultImage from "@/mocks/assets/defaultImage.png";
import { SingleProductImageFocusedPrice } from "./SingleProductImageFocusedPrice";
import { giftCardItem } from "@/utils/giftCardUtils";
import CloverGiftCardImage from "./cloverGiftCard.png";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export interface SingleProductProps {
  product: any;
  isRetailMerchant?: boolean;
}

export const SingleProductImageFocused = ({
  product,
  isRetailMerchant,
}: SingleProductProps) => {
  const isGiftCardProduct = product.id === giftCardItem.id;
  const productImage =
    product.images && product.images.length > 0
      ? product.images.reduce((prev: any, current: any) => {
          if (
            current.name.includes("xxxhdpi") ||
            (current.name.includes("xxhdpi") &&
              !prev.name.includes("xxxhdpi")) ||
            (current.name.includes("xhdpi") &&
              !prev.name.includes("xxhdpi") &&
              !prev.name.includes("xxxhdpi"))
          ) {
            return current;
          }
          return prev;
        }, product.images[0])
      : null;

  return (
    <div key={product.id} className={["flex", "flex-col", "gap-5"].join(" ")}>
      <div className="relative overflow-hidden rounded-md bg-gray-200 group-hover:opacity-75">
        <div className="relative pb-[133.33%]">
          {!isGiftCardProduct ? (
            <Image
              data-testid={applyDataTestId(pom.landingPage.productCardImage)}
              width={300}
              height={400}
              sizes="100vw"
              alt={product.name}
              src={productImage ? productImage.source : DefaultImage}
              className="absolute inset-0 w-full h-full object-cover"
            />
          ) : (
            <Image
              data-testid={applyDataTestId(pom.products.giftCardImage)}
              width={300}
              height={400}
              sizes="100vw"
              alt={product.name}
              src={CloverGiftCardImage}
              className="absolute inset-0 w-full h-full object-cover"
            />
          )}
          {!product.available && (
            <div className="absolute inset-0 bg-black opacity-40" />
          )}
        </div>
      </div>
      <div className={["flex", "flex-col", "gap-2"].join(" ")}>
        <p
          data-testid={applyDataTestId(pom.landingPage.productCardName)}
          className="truncate font-normal text-base leading-6"
        >
          {product.name}
        </p>
        <SingleProductImageFocusedPrice
          product={product}
          isGiftCardProduct={isGiftCardProduct}
          isRetailMerchant={isRetailMerchant}
        />
      </div>
    </div>
  );
};
